import axios from 'axios';

const getLoggedinUser = () => {
  const user = sessionStorage.getItem('authUser');
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

const getOffice = () => {
  const office = localStorage.getItem('@prosmed:office');
  if (!office) {
    return null;
  } else {
    return JSON.parse(office);
  }
};

// default
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// content type

axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';

// axios.defaults.headers.common["Access-Control-Allow-Credentials"] = "true";

// axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

// axios.defaults.headers.common["Access-Control-Allow-Methods"] =
//   "GET,HEAD,OPTIONS,POST,PUT";

axios.defaults.headers.common['Authorization'] = getLoggedinUser()
  ? getLoggedinUser().data.token
  : null;
axios.defaults.headers.common['Office'] = getOffice()
  ? getOffice().office_id
  : null;

const renewToken = async () => {
  const user = getLoggedinUser();
  if (user) {
    const response = await axios.post(`/auth/renew-token`);
    sessionStorage.setItem('authUser', JSON.stringify(response));
  }
};

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    const user = sessionStorage.getItem('authUser');
    if (user) {
      if (new Date(getLoggedinUser().data.date_to_renew) < new Date()) {
        renewToken();
      }
    }
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger

    let message;
    switch (error.response.status) {
      case 500:
        message = 'Internal Server Error';
        break;
      case 401:
        message = 'Invalid credentials';
        break;
      case 403:
        message = 'Forbidden';
        window.location.href = '/logout';
        break;
      case 404:
        message = 'Sorry! the data you are looking for could not be found';
        break;
      default:
        message = error;
    }
    return Promise.reject(error);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join('&') : '';
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

export { APIClient, setAuthorization, getLoggedinUser };
